var _g, _path, _g2, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddressInfoSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 174,
    viewBox: "0 0 266 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_626_501)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.354 3.35L2 121.355l207.646 28.776L226 32.126 18.354 3.35z",
    fill: "url(#paint0_linear_626_501)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M223.856 33.47L19.345 5.13 3.438 119.912l204.511 28.342 15.907-114.783z",
    fill: "#fff"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M218.838 37.698L23.103 10.573 8.592 115.285l195.734 27.125 14.512-104.712z",
    fill: "var(--color-secondary)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.62 16.863l68.223 113.223 41.501 5.759 72.459-42.176-57.199-75.697L63.227 123.893 5.265 102.089l103.561-91.15 84.44 131",
    fill: "var(--color-primary)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.62 16.863l68.223 113.223 41.501 5.759 72.459-42.176-57.199-75.697L63.227 123.893 5.265 102.089l103.561-91.15 84.44 131",
    stroke: "#fff",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.191 21.162c-1.4 10.103-22.182 31.231-22.182 31.231s-15.713-26.187-14.312-36.29a18.423 18.423 0 0136.143-2.179c.596 2.363.716 4.821.355 7.231l-.004.007z",
    fill: "url(#paint1_linear_626_501)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M99.993 21.481C98.679 30.958 79.184 50.78 79.184 50.78s-14.74-24.564-13.427-34.04a17.28 17.28 0 1134.232 4.745l.004-.004z",
    fill: "var(--color-primary)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.622 18.922c.657-4.739-2.643-9.11-7.37-9.766-4.728-.655-9.092 2.655-9.749 7.393-.657 4.739 2.643 9.111 7.37 9.766 4.728.655 9.092-2.655 9.75-7.393z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M240.758 104.486l-39.832 39.513a2.65 2.65 0 01-3.746-.015l-18.953-19.107a2.648 2.648 0 01.015-3.745l1.88-1.865a2.648 2.648 0 013.745.015l15.224 15.346 36.072-35.783a2.648 2.648 0 013.745.016l1.865 1.88a2.648 2.648 0 01-.015 3.745z",
    fill: "#49BC74"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_626_501",
    x1: 106.079,
    y1: 135.778,
    x2: 122.432,
    y2: 17.776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#989898",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#939393",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B6B6B",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_626_501",
    x1: 21238.6,
    y1: 15539.1,
    x2: 22358.7,
    y2: 7456.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_626_501",
    x: 0,
    y: 2.35,
    width: 228,
    height: 150.781,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_626_501"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_626_501",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressInfoSuccess);
export default __webpack_public_path__ + "static/media/addressInfoSuccess.108c71be29db7de82fb8539eb58c2513.svg";
export { ForwardRef as ReactComponent };